import styled from 'styled-components';

import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';

import backgroundSignIn from '../../../../assets/background-sign-in.png';

export const Card = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.05), 0 18px 50px rgba(16, 24, 40, 0.14);
`;

export const BoxLogo = styled(Box)`
  width: 100%;
  height: 5rem;
  display: flex;
  justify-content: center;

  background: url(${backgroundSignIn});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  img {
    width: auto;
    height: 5rem;
  }
`;
